import {
  Box,
  Group,
  Overlay,
  Paper,
  SimpleGrid,
  Skeleton,
  Stack,
} from '@mantine/core';

import { StatisticsHeader } from '../../components/statistics-header/statistics-header';

export function StatisticsSkeleton() {
  return (
    <Stack gap="md" mb="md">
      <Paper p="lg" radius="md" withBorder>
        <Stack gap="md">
          <Skeleton height={28} width={360} />
          <SimpleGrid cols={{ base: 1, sm: 2 }}>
            <Skeleton height={72} radius="md" />
            <Skeleton height={72} radius="md" />
          </SimpleGrid>
          <SimpleGrid cols={{ base: 1, md: 2 }}>
            <Skeleton height={96} radius="md" />
            <Skeleton height={96} radius="md" />
          </SimpleGrid>
          <Skeleton height={14} width="70%" />
        </Stack>
      </Paper>
      <SimpleGrid cols={{ base: 1, md: 2 }}>
        {Array.from({ length: 2 }).map((_, index) => (
          <Paper key={index} p="md">
            <Stack gap="md">
              <Group justify="space-between">
                <Skeleton height={28} width={120} />
                <Group gap="md">
                  <Skeleton height={18} width={140} />
                  <Skeleton height={18} width={140} />
                </Group>
              </Group>
              <SimpleGrid cols={{ base: 1, md: 2 }}>
                <Skeleton height={180} radius="md" />
                <Skeleton height={180} radius="md" />
              </SimpleGrid>
              <Skeleton height={240} radius="md" />
            </Stack>
          </Paper>
        ))}
      </SimpleGrid>
    </Stack>
  );
}

export function PendingPage() {
  return (
    <>
      <Box mb="md" pos="relative">
        <StatisticsHeader
          campaignYear={2026}
          clause="gp"
          onCampaignYearChange={() => undefined}
          onClauseChange={() => undefined}
          onOrganisationIdsChange={() => undefined}
          organisationIds={[]}
          showOwnerFilter
        />
        <Overlay opacity={0} />
      </Box>
      <StatisticsSkeleton />
    </>
  );
}

export default PendingPage;
